<!--TODO remove just for demo-->
@if(demoMode) {
  <hd-demo-header/>
}

<div class="flex overflow-y-auto" [ngClass]="demoMode ? 'calculated-height' : 'h-full'">
  <hd-side-menu></hd-side-menu>
  <div class="ml-[80px] w-full h-full overflow-x-auto">
    <router-outlet></router-outlet>
    <!-- TODO remove when going to production  -->
    @if(!demoMode) {
      <div class="flex fixed justify-end gap-2 bottom-0 right-0 mr-4">
        <div class="text-xs text-center p-1">{{userEmail}}</div>
        <hd-version></hd-version>
      </div>
      <div class="absolute bottom-6 right-4">
        <button class="outlined" (click)="openIssueReporter()">{{ 'issueReport.button' | translate }}</button>
      </div>
    }
  </div>
</div>
